import { render, staticRenderFns } from "./BaseNavDropdown.vue?vue&type=template&id=8f189262&"
import script from "./BaseNavDropdown.vue?vue&type=script&lang=js&"
export * from "./BaseNavDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports